import { render, staticRenderFns } from "./PhotostylePage.vue?vue&type=template&id=6efd87b9&scoped=true&"
var script = {}
import style0 from "./PhotostylePage.vue?vue&type=style&index=0&id=6efd87b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd87b9",
  null
  
)

export default component.exports